/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { rendererIconByName, ROW_DELETED_CLASS, truthyCellRenderer } from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { CostCenterListItem } from '../../resources/cost-center-list-item.model';

@Injectable()
export class CostCenterGridDefinition extends LayoutBasedGridDefinition {
  options = {
    getRowClass: ({ data }: { data: CostCenterListItem }) => {
      if (data.isActive !== true) {
        return ROW_DELETED_CLASS;
      }
    },
    getRowNodeId: (data: CostCenterListItem) => data.id,
  };

  columnDefs = {
    preferredSupplier: {
      valueGetter: ({ data }: { data: CostCenterListItem }) => data.suppliers?.find((supplier) => supplier.isPreferred)?.name || '',
    },
    isInJobSchedule: {
      cellRenderer: truthyCellRenderer(rendererIconByName('done')),
    },
  };
}
